import type { Auth0Client } from '@auth0/auth0-spa-js';

import { getAuth0Client, handleRedirectCallback } from './get-auth0-client';

export const getAuth0AuthenticatedClient = async (): Promise<Auth0Client> => {
    const auth0Client = await getAuth0Client();

    if (window.location.search.includes(`?code=`)) {
        await handleRedirectCallback(auth0Client);
        window.history.pushState({}, document.title, window.location.pathname);
    }

    const isAuthenticated = await auth0Client.isAuthenticated();
    if (!isAuthenticated) {
        throw new Error(`You must log in first.`);
    }

    return auth0Client;
};
